import { createSlice } from "@reduxjs/toolkit";
import {
  getRecordingStatus,
  getUplodRecordingList,
  saveAudio,
  updateSummary,
  updateTranscript,
  deleteTranscription,
} from "../services/speech-transcription.service";

const initialState = {
  saveUploadAudio: null,
  listUploadAudioData: [],
  loader: false,
  loaderTranscript: false,
  error: "",
  totalRecordCount: 0,
  total_pages: 0,
  isNext: false,
  recordingStatus: "",
  summaryResp: "",
  loaderSummary: false,
  errorSummary: "",
  successSummary: "",
  success: false,
  hideShowTranscript: {
    showTrans: false,
  },
  recordingStatusApiStopMsg: "",
  deleteLoader: false,
  deleteError: "",
};

const SpeechTranscriptionSlice = createSlice({
  name: "transcription",
  initialState,
  reducers: {
    HideShowTransScript: (state, action) => {
      state.hideShowTranscript = action.payload;
    },
    ResetValues: (state, action) => {
      state.saveUploadAudio = null;
      state.listUploadAudioData = [];
      state.loader = false;
      state.loaderTranscript = false;
      state.error = "";
      state.totalRecordCount = 0;
      state.total_pages = 0;
      state.isNext = false;
      state.recordingStatus = "";
      state.summaryResp = "";
      state.loaderSummary = false;
      state.errorSummary = "";
      state.successSummary = "";
      state.success = false;
      state.hideShowTranscript = {
        showTrans: false,
      };
      state.recordingStatusApiStopMsg = "";
    },
    setApiStopMsg: (state, action) => {
      state.recordingStatusApiStopMsg = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getUplodRecordingList.pending, (state, action) => {
        state.loader = true;
      })
      .addCase(getUplodRecordingList.fulfilled, (state, action: any) => {
        state.loader = false;
        if (action.payload && action.payload?.data) {
          state.listUploadAudioData = action.payload?.data?.results;
          state.success = action?.payload?.message;
          state.totalRecordCount = action.payload?.data?.count;
          state.total_pages = action.payload?.data?.total_pages;
          state.isNext = action.payload?.data?.next ? true : false;
        }
      })
      .addCase(getUplodRecordingList.rejected, (state, action: any) => {
        state.loader = false;
        state.error = action.error?.message
          ? action.error.message
          : "Recording List Api Error";
      })
      // Handle deleteTranscription lifecycle
      .addCase(deleteTranscription.pending, (state) => {
        state.deleteLoader = true;
        state.deleteError = "";
      })
      .addCase(deleteTranscription.fulfilled, (state, action) => {
        state.deleteLoader = false;
        state.listUploadAudioData = state.listUploadAudioData.filter(
          (item: any) => item.recording_id !== action.meta.arg
        );
      })
      .addCase(deleteTranscription.rejected, (state, action) => {
        state.deleteLoader = false;
        state.deleteError =
          action.error?.message || "Error deleting transcription.";
      })

      .addCase(saveAudio.pending, (state, action) => {
        state.loader = true;
      })
      .addCase(saveAudio.fulfilled, (state, action: any) => {
        state.saveUploadAudio = action.payload?.data;
        state.loader = true;
      })
      .addCase(saveAudio.rejected, (state, action: any) => {
        state.loader = false;
        state.error = action.error.message;
      })
      .addCase(getRecordingStatus.fulfilled, (state, action: any) => {
        state.loaderTranscript = true;
        if (action.payload && action.payload?.data) {
          state.recordingStatus = action.payload?.data?.results;
          state.summaryResp = action.payload?.data?.results[0]?.summary;
          if (
            action.payload?.data?.results[0].extracted_text ||
            (!action.payload?.data?.results[0].extracted_text &&
              (action.payload?.data?.results[0].status === "failed" ||
                action.payload.data?.results[0].status === "completed"))
          ) {
            state.loaderTranscript = false;
          }
        }
      })
      .addCase(getRecordingStatus.rejected, (state, action: any) => {
        state.loaderTranscript = false;
        state.error = action.error.message;
      })
      .addCase(updateTranscript.pending, (state, action: any) => {
        state.loader = false;
      })
      .addCase(updateTranscript.fulfilled, (state, action) => {
        state.loader = false;
      })
      .addCase(updateTranscript.rejected, (state, action: any) => {
        state.loader = false;
        state.error = action.error.message
          ? action.error.message
          : "Update Transcript Error";
      })
      .addCase(updateSummary.pending, (state, action: any) => {
        state.loaderSummary = false;
      })
      .addCase(updateSummary.fulfilled, (state, action: any) => {
        state.loaderSummary = false;
        if (action.payload && action.payload?.data) {
          state.successSummary = action.payload.message;
        } else {
          state.errorSummary = "Summary Not Updated";
        }
      })
      .addCase(updateSummary.rejected, (state, action: any) => {
        state.loaderSummary = false;
        state.errorSummary = action.error.message
          ? action.error.message
          : "Update Sumamry Error";
      });
  },
});

export const { HideShowTransScript, ResetValues, setApiStopMsg } =
  SpeechTranscriptionSlice.actions;
export default SpeechTranscriptionSlice.reducer;
